import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../../util/Rest';
import {AR} from '../../../constants/MicroServiceConstants';

const initialData = {
  batchDetailsData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'cashBalanceReport',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchBatchDetailsData: (state, action) => {
      state.batchDetailsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchBatchDetailsData, fetchError} = slice.actions;
export const fetchBatchDetails = (cashBatchId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${AR}/find/batchdetails/${cashBatchId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchBatchDetailsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
